import { DataBean } from "../DataBean";


export class Training extends DataBean {


    public async getTrainingCatalog(idLn: number, idAppoManual: number, type: number | null): Promise<any> {
        return this.getCustomService("PeopleArt", "java.util.List_getTrainingCatalog_Number_Number_Number", [idLn, idAppoManual, type]);
    }

    public async deleteTraining(bean): Promise<any> {
        return this.getCustomService("PeopleArt", "void_deleteTraining_com.peopleart.bean.appointment.Training", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.peopleart.bean.appointment.Training"
            }
        ]);
    }
}